import {DateAsString, ExperienceResource} from '@/common/api/api-raw-types';
import {Experience} from '../../../domain/experience/Experience';

function _toDateAsString(date: Date): DateAsString {
    return date.toISOString();
}

export function toExperienceResource(experience: Experience): ExperienceResource {
    // TODO fix type!
    return {
        id: experience.id,
        companyId: experience.companyId,
        endDate: experience.endDate ? _toDateAsString(experience.endDate) : undefined,

        area: experience.area,
        asFreelance: experience.asFreelancer,
        company: experience.company,
        currentJob: experience.isCurrentJob,
        description: experience.description,
        location: experience.location,
        startDate: _toDateAsString(experience.startDate),
        title: experience.title,
        requestOrigin: 'SIGNUP',
    } as any;
}
